import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';
import {fetchParameterGroupList, setParameterGroupListAction} from "./system-parameter-group.action";
import {SystemParameterGroupService} from "../services/parameter-group.service";

@Injectable()
export class SystemParameterGroupEffects {


  loadSystemParameterGroups$ = createEffect(() => this.actions$.pipe(
    ofType(fetchParameterGroupList),
    switchMap(() => this.systemParameterGroupService.getList()
      .pipe(
        map(list => setParameterGroupListAction(list)),
        catchError(err => of({type: 'Error Occurred', error: err}))
      ))
  ))

  constructor(
    private readonly actions$: Actions,
    private readonly systemParameterGroupService: SystemParameterGroupService
  ) {
  }
}
